import { GestureController } from '@ionic/angular';
import { PasswordResettingPanelController } from './PasswordResettingPanelController';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Fade, SlideLeft, SlideRight } from 'src/app/Util/AnimationUtil';

import { BasePanelSlide } from 'src/app/View/BaseUI/BasePanelSlide';
import { MatDialog } from '@angular/material/dialog';
import { PopoverAlertComponent } from '../../../../../Common/Popover/Alert/PopoverAlertComponent';
import { SuccessSendForgetPasswordPopupComponent } from 'src/app/View/Common/SuccessSendForgetPasswordPopup/SuccessSendForgetPasswordPopupComponent';
import { ForgetPasswordLogginedPopupComponent } from './ForgetPasswordPopup/ForgetPasswordLogginedPopupComponent';


/**
 * PasswordResettingPanelComponent
 * パスワード変更パネル
 */
@Component({
	selector: 'PasswordResettingPanelComponent',
	templateUrl: './PasswordResettingPanelComponent.html',
	styleUrls: ['./PasswordResettingPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class PasswordResettingPanelComponent extends BasePanelSlide {

	// 対となるコントローラー
	public combineCtrl: PasswordResettingPanelController;

	// ジェスチャー対象のElement参照
	@ViewChild('gesturePage', { read: ElementRef, static: false }) gesturePage: ElementRef;

	// ユーザー情報入力データ。HTMLからバインドされる。
	public form: any = {};
	// パスワードの不可視化フラグ
	public hide = true;

	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog, public renderer: Renderer2) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		this.createController(PasswordResettingPanelController);
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// スライドイン表示は自分でやる
		await this.slideIn();

		// ジェスチャーを与える対象を設定する
		this.setGestureTargetElementRef(this.gesturePage);

	}

	/**
	 * onClickResettingPassword
	 * パスワード変更を行う。
	 * 変更成功後は完了ポップアップを表示する。
	 */
	public async onClickResettingPassword() {

		// リセット
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.resetPassword.bind(this),
			{ view: this, oldPass: this.form.oldPass, newPass: this.form.newPass }
		);
		if (!ret) {
			return;
		}

		// リセット完了ポップアップの表示
		this.showDialogWindow(
			PopoverAlertComponent,
			{
				title: '確認',
				text: 'パスワードを再設定しました。',
				close: this.confirmReceive.bind(this)
			 }
		);

	}

	/**
	 * onClickForetPassword
	 * パスワード忘れ時の動作。
	 * ポップアップを表示する
	 */
	public async onClickForetPassword() {

		this.log('onClickForetPassword');
		await this.showDialogWindow(
			ForgetPasswordLogginedPopupComponent,
			{
				success: this.successSendMail.bind(this),
				close: this.cancelSendMail.bind(this)
			}
		);

	}

	//////////////////////////////////////
	// 別画面からの処理
	/**
	 * confirmReceive
	 * ポップアップ画面から呼び出される
	 */
	public async confirmReceive() {

		// ポップアップを閉じる
		await this.dismissDialogWindow();
		// 画面をスライドアウトさせる
		await this.closeSelfView();

	}

	/**
	 * cancelSendMail
	 * パスワード忘れメールy送信キャンセル時
	 */
	public async cancelSendMail() {

		// ポップアップを閉じる
		await this.dismissDialogWindow();

	}

	/**
	 * successSendMail
	 * メール送信が成功したときの処理
	 * ポップアップ先からコールされる
	 */
	public async successSendMail() {

		// 表示していたポップアップを閉じる
		await this.dismissDialogWindow();

		// メール送信完了のポップアップを別で表示
		this.log('successSendMail');
		await this.showDialogWindow(
			SuccessSendForgetPasswordPopupComponent,
			{
				close: this.confirmReceive.bind(this)
			}
		);

	}

}
